const BadgeClassic = ({ label, value = 0 }) => {
    const state = parseFloat(value) > 0 ? 'success' : parseFloat(value) < 0 ? 'error' : 'info';

    return(
        <div className={`badgeClassic badgeClassic--${state}`}>
            {label}
        </div>
    )
}

export default BadgeClassic;